import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { NavbarComponent } from './components/layout/navbar/navbar.component';
import {
  EqualValidator, NotEqualValidator, ValidPersonnummerValidator, GreaterThanValidator, RequireFieldValidator,
  RequireFieldIfSetValidator, ExistingPersonnummerValidator, ValidTelefonnummerValidator
} from './common/helper/formValidator';
import { KeysPipe } from './common/helper/pipes/keys.pipe';
import { SharedModule } from './common/shared/shared.module';
import { MaterialModule } from './common/modules/material/material.module';

import { CustomFontAwesomeModule } from './common/modules/font-awesome/custom-font-awesome.module';
import { AuthService } from './common/shared/services/auth.service';

import { MomentModule } from 'ngx-moment';
import { DialogService } from './common/shared/services/dialog.service';
import { NavigationService } from './common/shared/services/navigation.service';
import { LoginComponent } from './components/handle-user/login/login.component';
import { AuthInterceptor } from './common/helper/authInterceptor';
import { FooterbarComponent } from './components/layout/footerbar/footerbar.component';

import { environment } from '../environments/environment';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { RegisterComponent } from './components/handle-user/register/register.component';
import { PersonalDataViewComponent } from './components/profile/personalData/personal-data-view/personal-data-view.component';
import { EmploymentViewComponent } from './components/profile/employment/employment-view/employment-view.component';
import { OrganisationViewComponent } from './components/profile/organisation/organisation-view/organisation-view.component';
import { OrganisationFormComponent } from './components/profile/organisation/organisation-form/organisation-form.component';
import { EmploymentFormComponent } from './components/profile/employment/employment-form/employment-form.component';
import { PersonalDataFormComponent} from './components/profile/personalData/personal-data-form/personal-data-form.component';
import { ChangePasswordComponent } from './components/handle-user/change-password/change-password.component';
import { ResetPasswordComponent } from './components/handle-user/reset-password/reset-password.component';
import { TermsComponent } from './components/terms/terms/terms.component';
import { ChangeEmailComponent } from './components/handle-user/change-email/change-email.component';
import { ConsentGuard } from './common/guards/consent.guard';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AlertDialogComponent } from './components/layout/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './components/layout/confirm-dialog/confirm-dialog.component';
import { BenefitFormComponent } from './components/profile/benefits/benefit-form/benefit-form.component';
import { BenefitViewComponent } from './components/profile/benefits/benefit-view/benefit-view.component';
import { OccupationFormComponent } from './components/profile/employment/occupation-form/occupation-form.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.serviceBaseUrl + 'translation/', '?api_key=' + environment.backendApiKey);
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PageNotFoundComponent,
    LoginComponent,
    KeysPipe,
    EqualValidator,
    NotEqualValidator,
    ValidPersonnummerValidator,
    ValidTelefonnummerValidator,
    ExistingPersonnummerValidator,
    GreaterThanValidator,
    RequireFieldValidator,
    RequireFieldIfSetValidator,
    FooterbarComponent,
    RegisterComponent,
    ProfileComponent,
    PersonalDataViewComponent,
    PersonalDataFormComponent,
    EmploymentViewComponent,
    EmploymentFormComponent,
    OrganisationViewComponent,
    OrganisationFormComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    TermsComponent,
    ChangeEmailComponent,
    AlertDialogComponent,
    ConfirmDialogComponent,
    BenefitFormComponent,
    BenefitViewComponent,
    OccupationFormComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    RouterModule.forRoot(
      appRoutes,
      { anchorScrolling: 'enabled' }
      // { enableTracing: false } // <-- debugging purposes only
    ),
    ModalModule.forRoot(),
    BootstrapModalModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    SharedModule.forRoot(),
    MaterialModule,
    CustomFontAwesomeModule,
    MomentModule,
    ReCaptchaModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'sv-SV' },
    DialogService,
    NavigationService,
    AuthService,
    ConsentGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
